import config from "src/config";
import { shouldSkipLabelPrintInDev } from "src/apis/labelApi";

const itemLabelUrl = `${config.apiUrl}/label/item`;

/**
 * itemCd 기반 라벨 데이터 (LOT 개념 없음)
 */
export interface ItemLabelPrintData {
	itemCd: string;
	itemNm: string;
	itemSpec: string;
	qty: string;              // "2,000EA" 형태
	transportDate: string;
	storageLocation: string;
	customer: string;
	customerItemCd: string;
	labelType: string;        // "[생산입고]" 등
}

export interface ItemLabelBulkRequest {
	labels: ItemLabelPrintData[];
}

/**
 * 품목 라벨 다중 브라우저 인쇄 (QZ 미연결 시 폴백용)
 * 한 페이지에 렌더링된 HTML을 새 창에 띄우고 print() 호출
 */
export const printItemBulkLabelsAtOnce = async (
	dataList: ItemLabelPrintData[]
): Promise<Window | null> => {
	if (shouldSkipLabelPrintInDev()) return null;
	if (!dataList || dataList.length === 0) return null;

	const url = `${itemLabelUrl}/print/browser`;
	const response = await fetch(url, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ labels: dataList }),
	});

	if (!response.ok) throw new Error(`품목 라벨 생성 실패: ${response.status}`);

	const html = await response.text();
	const printWindow = window.open('', '_blank', 'width=800,height=600');
	if (!printWindow) throw new Error('팝업 차단으로 인해 창을 열 수 없습니다.');

	printWindow.document.open();
	printWindow.document.write(html);
	printWindow.document.close();

	setTimeout(() => {
		try { if (!printWindow.closed) printWindow.print(); } catch { /* noop */ }
	}, 400);

	return printWindow;
};

/**
 * 품목 라벨 다중 출력용 HTML을 문자열로 조회 (QZ Tray print()에 그대로 넘기기 위함)
 */
export const fetchItemBulkLabelHtml = async (dataList: ItemLabelPrintData[]): Promise<string> => {
	const url = `${itemLabelUrl}/print/bulk`;
	const response = await fetch(url, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ labels: dataList }),
	});
	if (!response.ok) throw new Error(`HTTP ${response.status}`);
	return await response.text();
};
